import { request } from './request';

export const getAllTasks = (page = 1, queryString = '') =>
  request(`tasks?page=${page}${queryString}&limit=50`);

export const createTask = (body) =>
  request(
    `tasks`,
    {
      method: 'POST',
      body,
    },
    'Task created successfully!',
  );

export const updateTask = (id, body) =>
  request(
    `tasks/${id}`,
    { method: 'PATCH', body },
    'Task updated successfully!',
  );

export const deleteTask = (id) =>
  request(
    `tasks/${id}`,
    {
      method: 'DELETE',
    },
    'Task deleted successfully!',
  );
